import { render, staticRenderFns } from "./QuotationObject.vue?vue&type=template&id=08a5d5df&scoped=true"
import script from "./QuotationObject.vue?vue&type=script&lang=ts"
export * from "./QuotationObject.vue?vue&type=script&lang=ts"
import style0 from "./QuotationObject.vue?vue&type=style&index=0&id=08a5d5df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a5d5df",
  null
  
)

export default component.exports